import { render, staticRenderFns } from "./class-course-info.vue?vue&type=template&id=64db21e6&scoped=true&"
import script from "./class-course-info.vue?vue&type=script&lang=ts&"
export * from "./class-course-info.vue?vue&type=script&lang=ts&"
import style0 from "./class-course-info.vue?vue&type=style&index=0&id=64db21e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db21e6",
  null
  
)

export default component.exports